$('.button--input-share').on("click", function(event) {
    $('#share-input').select();
    document.execCommand('copy');
})